import WebsiteVisits from "../../components/Insights/website";
import { connect } from "react-redux";
import {
  getStatsByDeviceType,
  getStatsByDeviceModel,
  getStatsByOsType,
  setReportDayRange,
  getStatsByPopularPage,
  getStatsByRegionalTraffic,
  setReportWebSiteId,
  getStatsByTimeofDay,
  getStatsByTime,
  getStatsByDemographic,
  getStatsByPrimaryDevices,
  clearAllStats,
  getStatsTopAttributes,
  getHeatMapData,
  getDomesticVisits,
  sendAssistRequest,
  getDomesticBusinessStats,
  getTop20FrequencyBusiness,
  getStates,
  setReportGranularity,
} from "../../actions/Insights";
import { getClientSites, getClientTags } from "../../actions/Clients";
import { getClientInfo, selectClient } from "../../actions/App";

const mapStateToProps = state => {
  const {
    statsByDevice,
    statsByDeviceModel,
    statsByOsType,
    statsByTime,
    statsByPopularPages,
    statsByRegionalTraffic,
    statsByTimeOfDay,
    domesticVisitsSummary,
    statsByPrimaryDevices,
    statsByDemographic,
    statsTopAttributes,
    websiteId,
    dayRange,
    granularity,
    heatMapPoints,
    send_assist_request_error,
    request_assist_successful,
    domesticBusinessVisitsReport,
    top20FrequencyBusinesses,
    loadingDomesticVisitsSummary,
    loadingStatsByDeviceType,
    loadingStatsByTime,
    loadingStatsByPopularPage,
    loadingStatsByRegionalTraffic,
    loadingStatsByTimeOfDay,
    loadingStatsByDemographic,
    loadingStatsByPrimaryDevices,
    loadingStatsTopAttributes,
    loadingTop20FrequencyBusinesses,
    loadingStatsByDeviceModel,
    loadingStatsByOsType,
    states,
  } = state.insights;
  const { selected_client, clients, client_info, roleId } = state.app;
  const { client_sites, client_tags } = state.clients;
  return {
    websiteId,
    client_info,
    selected_client,
    clients,
    client_sites,
    client_tags,
    dayRange,
    granularity,
    statsByDevice,
    statsByDeviceModel,
    statsByOsType,
    statsByTime,
    statsByPopularPages,
    statsByRegionalTraffic,
    statsByTimeOfDay,
    statsByDemographic,
    statsByPrimaryDevices,
    statsTopAttributes,
    heatMapPoints,
    domesticVisitsSummary,
    domesticBusinessVisitsReport,
    send_assist_request_error,
    request_assist_successful,
    top20FrequencyBusinesses,
    loadingDomesticVisitsSummary,
    loadingStatsByDemographic,
    loadingStatsByDeviceType,
    loadingStatsByTime,
    loadingStatsByPopularPage,
    loadingStatsByRegionalTraffic,
    loadingStatsByTimeOfDay,
    loadingStatsTopAttributes,
    loadingStatsByPrimaryDevices,
    loadingTop20FrequencyBusinesses,
    loadingStatsByOsType,
    loadingStatsByDeviceModel,
    roleId,
    states,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    selectClient: id => {
      dispatch(selectClient(id));
    },
    getClientInfo: id => {
      dispatch(getClientInfo(id));
    },
    getClientTags: clientId => {
      dispatch(getClientTags(clientId));
    },
    getStatsByDeviceType: (wid, dateRange, type, popUrl) => {
      dispatch(getStatsByDeviceType(wid, dateRange, type, popUrl));
    },

    getStatsByDeviceModel: (wid, dateRange, type) => {
      dispatch(getStatsByDeviceModel(wid, dateRange, type));
    },

    getStatsByOsType: (wid, dateRange, type) => {
      dispatch(getStatsByOsType(wid, dateRange, type));
    },

    getStatsByTime: (wid, dateRange, page, type) => {
      dispatch(getStatsByTime(wid, dateRange, page, type));
    },

    getStatsByPopularPages: (wid, dateRange, type) => {
      dispatch(getStatsByPopularPage(wid, dateRange, type));
    },

    getStatsByRegionalTraffic: (wid, dateRange, page, type) => {
      dispatch(getStatsByRegionalTraffic(wid, dateRange, page, type));
    },

    getStatsByTimeOfDay: (wid, dateRange, page, type) => {
      dispatch(getStatsByTimeofDay(wid, dateRange, page, type));
    },

    getStatsByDemographic: (wid, dateRange, page, type, granularity) => {
      dispatch(getStatsByDemographic(wid, dateRange, page, type, granularity));
    },

    getStatsByPrimaryDevices: (wid, dateRange, page) => {
      dispatch(getStatsByPrimaryDevices(wid, dateRange, page));
    },

    getStatsTopAttributes: (wid, dateRange, page, type, granularity) => {
      dispatch(getStatsTopAttributes(wid, dateRange, page, type, granularity));
    },

    getClientSites: cid => {
      dispatch(getClientSites(cid, true));
    },

    clearAllStats: () => {
      dispatch(clearAllStats());
    },

    setWebsiteId: id => {
      dispatch(setReportWebSiteId(id));
    },

    setDateRange: str => {
      dispatch(setReportDayRange(str));
    },

    setGranularity: str => {
      dispatch(setReportGranularity(str));
    },

    getHeatMapData: (wid, dateRange, page, type) => {
      dispatch(getHeatMapData(wid, dateRange, page, type));
    },

    getDomesticVisits: (tagId, dateRange, type, page) => {
      dispatch(getDomesticVisits(tagId, dateRange, type, page));
    },

    sendAssistRequest: data => {
      dispatch(sendAssistRequest(data));
    },

    getDomesticBusinessStats: (tagId, granularity, dateRange) => {
      dispatch(getDomesticBusinessStats(tagId, dateRange, granularity));
    },

    getTop20FrequencyBusiness: (tagId, dateRange) => {
      dispatch(getTop20FrequencyBusiness(tagId, dateRange));
    },
    getStates: (siteId, dateRange, page, reportType) => {
      dispatch(getStates(siteId, dateRange, page, reportType));
    },
  };
};

const WebsiteVisitsContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(WebsiteVisits);

export default WebsiteVisitsContainer;



// WEBPACK FOOTER //
// ./src/containers/Insights/WebsiteVisits.js